module.exports = __webpack_public_path__ + "static/mw4-7b98e887934b8c609c69b6a467b153f0.jpg";